"use strict";

exports.__esModule = true;
var _AlertTagSelector = require("./AlertTagSelector");
Object.keys(_AlertTagSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AlertTagSelector[key]) return;
  exports[key] = _AlertTagSelector[key];
});